import angular from 'angular';
import currencyPickReportComponent from './currency_pick_report.component';
import printCurrencyPickReportComponent from './print_currency_pick_report/print_currency_pick_report.component';

const currencyPickReportModule = angular.module('currencyPickReport', [])
  .component('currencyPickReport', currencyPickReportComponent)
  .component('printCurrencyPickReport', printCurrencyPickReportComponent)
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';
    $stateProvider
      .state('orderPacking.currencyPickReport', {
        url: '/currency-pick-report',
        views: {
          '@app': {
            component: 'currencyPickReport'
          }
        },
        data: {
          requireLogin: true,
          requireACL: 'currency_pick_report.view'
        }
      })
      .state('printCurrencyPickReport', {
        url: '/currency-pick-report/print',
        component: 'printCurrencyPickReport',
        data: {
            requireLogin: true,
            layout: 'blank'
        }
      });
  })
  .name;

export default currencyPickReportModule;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/currency_pick_report/index.js